module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.75eec410.jpg";